import { merge } from '../../helper';

// ----------------------------------------------------------------------------

function outside(element: HTMLElement, config: Record<string, any> = {}): any {
    // Default Config
    const defConfig: Record<string, any> = {
        parent: document,
        type: 'click',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Function Outside
    const fnOutside = function (this: any, evt): any {
        let elTarget = evt.target;

        do {
            // If using function callback
            if (typeof config.fnCallback === 'function') {
                const res = config.fnCallback.call(this, evt);

                if (res === true) {
                    return;
                }
            }

            //
            if (elTarget === element) {
                // If using function inside
                if (typeof config.fnInside === 'function') {
                    config.fnInside.call(this, evt);
                }

                return;
            }

            elTarget = elTarget.parentNode;
        } while (elTarget);

        // If using function outside
        if (typeof config.fnOutside === 'function') {
            config.fnOutside.call(this, evt);
        }
    };

    // Create event
    defConfig.parent.addEventListener(defConfig.type, fnOutside);

    // Return
    return fnOutside;
}

// ----------------------------------------------------------------------------

export { outside };
